import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib';
import * as actions from './checkin-acceptance-result.actions';
import { CheckinAcceptanceResultState } from './checkin-acceptance-result.state';

/**
 * checkinAcceptanceResult initial state
 */
export const checkinAcceptanceResultInitialState: CheckinAcceptanceResultState = {
  checkinAcceptanceResult: null,
  requestIds: [],
};

/**
 * List of basic actions for CheckinAcceptanceResult Store
 */
export const checkinAcceptanceResultReducerFeatures: ReducerTypes<CheckinAcceptanceResultState, ActionCreator[]>[] = [
  on(actions.setCheckinAcceptanceResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateCheckinAcceptanceResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetCheckinAcceptanceResult, () => checkinAcceptanceResultInitialState),

  on(actions.cancelCheckinAcceptanceResultRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failCheckinAcceptanceResult, (state, payload) =>
    asyncStoreItemAdapter.failRequest(state, payload.requestId)
  ),

  on(actions.setCheckinAcceptanceResultFromApi, actions.updateCheckinAcceptanceResultFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * CheckinAcceptanceResult Store reducer
 */
export const checkinAcceptanceResultReducer = createReducer(
  checkinAcceptanceResultInitialState,
  ...checkinAcceptanceResultReducerFeatures
);
